import React from 'react'
import { inject, observer } from 'mobx-react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { Button, CircularProgress } from '@material-ui/core'
import { RegistrationStore, UnsubscribeResult } from '../../stores/registration-store'

const SuccessMark = require('../../assets/success-mark.svg')
const FailureMark = require('../../assets/failure-mark.svg')
const styles = require('./unsubscribe.module.scss')

interface UnsubscribeProps extends RouteComponentProps<{ clientId: string, encodedData: string }> {
    registrationStore?: RegistrationStore
}

const UnsubscribeInner: React.FC<UnsubscribeProps> = inject(
    RegistrationStore.storeName,
)(observer(
    props => {
        const { unsubscribeClient, unsubscribeResult } = props.registrationStore
        const { clientId, encodedData } = props.match.params

        React.useEffect(() => {
            document.title = 'Set Loyalty'
            unsubscribeClient(clientId, encodedData)
        }, [])

        if (unsubscribeResult === null) {
            return (
                <div className={styles.background} style={{ justifyContent: 'center' }}>
                    <CircularProgress/>
                </div>
            )
        }

        let already = unsubscribeResult === UnsubscribeResult.ALREADY
        let success = unsubscribeResult === UnsubscribeResult.SUCCESS || already

        // Отключено пока нет бэка
        let companyName = ''
        let messageText = 'Вы успешно отписались от рассылки'
        let buttonText = 'ПЕРЕЙТИ НА САЙТ'
        let buttonLink = ''

        let errorText = 'Не удалось отказаться от рассылки'
        let errorComment = 'Обратитесь в техническую поддержку'

        let buttonURL = buttonLink
        if (buttonURL.search('http') !== 0) {
            buttonURL = `https://${buttonURL}`
        }

        const button = buttonLink ? (
            <Button
                color="primary"
                variant="contained"
                href={buttonURL}
            >
                {buttonText}
            </Button>
        ) : null

        return (
            <div className={styles.background}>
                <div className={styles.content}>
                    <div className={styles.text}>{companyName}</div>

                    {success ? (
                        <>
                            <img id="successIcon" src={SuccessMark} className={styles.icon} alt="Success" />
                            <div id="successText" className={styles.text}>{messageText}</div>
                        </>
                    ) : (
                        <>
                            <img id="errorIcon" src={FailureMark} className={styles.icon} alt="Error" />
                            <div id="errorText" className={styles.text}>{errorText}</div>
                        </>
                    )}
                </div>

                {success ? (
                    button
                ) : (
                    <div id="errorComment" className={styles.comment}>
                        {errorComment}
                    </div>
                )}
            </div>
        )
    }
))

export const Unsubscribe = withRouter(UnsubscribeInner)
